
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalStudentMailAddress from '@/components/templates/ModalStudentMailAddress.vue'
import { ReconfigureMailAddressesApi } from '@/api/methods/ReconfigureMailAddressesApi'

/**
 * 生徒メールアドレス変更モーダル
 */
@Component({
  components: {
    ModalStudentMailAddress,
  },
})
export default class ModalEditStudentMailAddress extends Vue {
  /** 生徒メールアドレス変更モーダルのフォーマット */
  @Ref()
  modalStudentMailAddress!: ModalStudentMailAddress

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    // メールアドレスのバリデーションチェック
    const errorMessage = this.validateMailAddress()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 新しいメールアドレスを再設定テーブルに登録
    await ReconfigureMailAddressesApi.applyNewAddress(this.modalStudentMailAddress.mailAddress)

    this.$loading.complete()

    // 受付完了メッセージ表示
    alert('メールアドレス変更を受付ました。\n新しいアドレス宛に送信したURLから、変更を確定してください。')

    // モーダルを閉じる
    this.hide()
  }

  /**
   * メールアドレスのバリデーションチェック
   *
   * @returns アドレス不正時はエラーメッセージを返す
   */
  private validateMailAddress(): string | null {
    if (!this.modalStudentMailAddress.mailAddress.match(/.+@.+\..+/)) {
      return '入力されたメールアドレスが正しくありません'
    }

    return null
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.modalStudentMailAddress.show()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalStudentMailAddress.hide()
  }
}
